<app-record-pagination
  *ngIf="publicState()"
  [state]="publicState()"
  [showTopNavigation]="showTopNavigation"></app-record-pagination>

<ng-container *ngIf="list">
  <div class="header">
    <h1>{{ list.name }}</h1>
    <opac-button
      *ngIf="isOwner"
      class="more-actions"
      [opac-menu-trigger]="listOwnerActionsMenu"
      [ariaLabel]="'lists.moreActions' | translate"
      [opacTooltip]="'lists.moreActions' | translate">
      <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
    </opac-button>

    <opac-button
      *ngIf="!isOwner"
      class="more-actions hide-tablet"
      [opac-menu-trigger]="listSharedActionsMenu"
      [ariaLabel]="'lists.moreActions' | translate"
      [opacTooltip]="'lists.moreActions' | translate">
      <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
    </opac-button>

    <opac-button
      *ngIf="!isOwner && showFollowListButton"
      class="follow-button hide-mobile"
      type="tertiary"
      (click)="followList()">
      {{ 'lists.follow' | translate }}
    </opac-button>

    <opac-button
      *ngIf="!isOwner && showUnfollowListButton"
      class="follow-button hide-mobile"
      type="tertiary"
      (click)="unfollowList()">
      {{ 'lists.unfollow' | translate }}
    </opac-button>

    <opac-button
      *ngIf="!isOwner"
      class="share-button hide-mobile"
      [ariaLabel]="'tooltip.copyLink' | translate"
      [opacTooltip]="'tooltip.copyLink' | translate"
      (click)="copyToClipboard()">
      <opac-icon icon="link" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <opac-menu #listOwnerActionsMenu>
    <opac-menu-item (selected)="editList()">
      <opac-icon icon="edit"></opac-icon>
      {{ 'common.edit' | translate }}
    </opac-menu-item>

    <opac-menu-item (selected)="addTitles()">
      <opac-icon icon="add"></opac-icon>
      {{ 'lists.addTitles' | translate }}
    </opac-menu-item>

    <opac-menu-item *ngIf="!list.privateList" (selected)="copyToClipboard()">
      <opac-icon icon="share"></opac-icon>
      {{ 'tooltip.copyLink' | translate }}
    </opac-menu-item>

    <opac-menu-item (selected)="showEmptyListDialog.set(true)">
      <opac-icon icon="delete"></opac-icon>
      {{ "lists.emptyList" | translate }}
    </opac-menu-item>

    <opac-menu-item (selected)="showDeleteListDialog.set(true)">
      <opac-icon icon="delete"></opac-icon>
      {{ "lists.remove" | translate }}
    </opac-menu-item>
  </opac-menu>

  <opac-menu #listSharedActionsMenu>
    <opac-menu-item *ngIf="showFollowListButton" (selected)="followList()">
      <opac-icon icon="follow"></opac-icon>
      {{ 'lists.follow' | translate }}
    </opac-menu-item>

    <opac-menu-item *ngIf="!showFollowListButton" (selected)="unfollowList()">
      <opac-icon icon="unfollow"></opac-icon>
      {{ 'lists.unfollow' | translate }}
    </opac-menu-item>

    <opac-menu-item (selected)="copyToClipboard()">
      <opac-icon icon="link" slot="only-icon"></opac-icon>
      {{ 'tooltip.copyLink' | translate }}
    </opac-menu-item>
  </opac-menu>

  <span class="header-subtitle">
    <span>{{ (list.privateList ? 'lists.private' : 'lists.public') | translate }} · </span>
    <span>{{ list.items.length }} {{ (list.items.length === 1 ? "common.item" : "common.items") | translate }}</span>
    <span *ngIf="!list.privateList" class="list-followers">
      <opac-icon icon="follower"></opac-icon>
      {{ list.followers }} {{ (list.followers === 1 ? "lists.follower" : "lists.followers") | translate }}
    </span>
  </span>

  <p class="list-description" *ngIf="list.description">{{ list.description }}</p>
</ng-container>

<opac-divider></opac-divider>

<div class="skeleton-container" *ngIf="!records.length && waiting">
  <opac-card-item-skeleton *ngFor="let i of [1, 2, 3, 4, 5, 6]"></opac-card-item-skeleton>
  <opac-gradient></opac-gradient>
</div>

<opac-no-results-cta *ngIf="list?.items.length === 0 && isOwner">
  {{ 'lists.noElements' | translate }}
  <opac-button *ngIf="!forListSubscriptions" type="secondary" (click)="addTitles()">
    {{ 'lists.addElements' | translate }}
  </opac-button>
</opac-no-results-cta>

<opac-no-results *ngIf="list?.items.length === 0 && !isOwner" [label]="'lists.empty.label' | translate"> </opac-no-results>

<app-record-card-grid *ngIf="list?.items.length > 0">
  <opac-card-item
    *ngFor="let record of records; let i = index"
    [title]="record.title"
    [author]="record.author"
    [cover]="{ url: record.coverImageUrl, icon: record.icon }"
    [link]="record | infoUrl: null : getState(i)">
    <opac-card-item-social>
      <app-rating class="interactions__rating" [record]="record" [rating]="record.rating" [readOnly]="readOnly">
      </app-rating>
      <app-favorite-button [recordId]="record.id"></app-favorite-button>
      <app-more-option-button
        [showCiteButton]="true"
        [showReportButton]="true"
        [recordItem]="record"></app-more-option-button>
    </opac-card-item-social>

    <opac-card-item-details *ngIf="isOwner">
      <opac-card-item-detail [label]="'user.favorites.dateAdded' | translate">
        {{ list.items[i].creationDate | date }}
      </opac-card-item-detail>
    </opac-card-item-details>

    <div class="actions">
      <app-record-buttons from="USER_SCREEN" [record]="record" [config]="buttonsConfig"> </app-record-buttons>

      <button
        mat-flat-button
        class="warn transparent delete-button"
        *ngIf="isOwner"
        (keydown.enter)="removeRecordFromList(record.id)"
        (keydown.space)="removeRecordFromList(record.id)"
        (click)="removeRecordFromList(record.id)">
        {{ "common.delete" | translate }}
      </button>
    </div>

    <opac-card-item-description *ngIf="!isOwner" [description]="record?.description"></opac-card-item-description>
  </opac-card-item>
</app-record-card-grid>

<opac-infinite-scroll
  [disabled]="!hasLoadMore && !waiting"
  [threshold]="100"
  (load)="loadMore()"></opac-infinite-scroll>

<opac-confirmation-dialog
  [acceptLabel]="'common.delete'"
  [open]="showEmptyListDialog()"
  [title]="'lists.emptyList' | translate"
  (accept)="emptyList()"
  (cancel)="showEmptyListDialog.set(false)">
  <p>{{ 'lists.empty.confirm.message' | translate }}</p>
</opac-confirmation-dialog>
<opac-confirmation-dialog
  [acceptLabel]="'common.delete'"
  [open]="showDeleteListDialog()"
  [title]="'lists.empty.confirm.title' | translate"
  (accept)="deleteList()"
  (cancel)="showDeleteListDialog.set(false)">
  <p [innerHTML]="descriptionToDeleteListDialog() | translate"></p>
</opac-confirmation-dialog>
